import styles from './gosuslugi-card.module.scss';

type GosuslugiCardProps = {
  title: string;
  description: string;
  iconSrc: HTMLImageElement['src'];
};

export const GosuslugiCard = ({ title, description, iconSrc }: GosuslugiCardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <img src={iconSrc} alt="" width={25} height={24} />
        <span className={styles.header}>{title}</span>
      </div>
      <div className={styles.text}>{description}</div>
    </div>
  );
};
